import React from 'react';

type CustomButtonType = {
  name: string;
  onClick?: (id?: string) => void;
};

const CustomButton = ({ name, onClick }: CustomButtonType) => {
  return (
    <div
      className='w-[156px] h-[39px] flex items-center justify-center bg-[#483838] text-white rounded-[4px] text-[14px] float-right cursor-pointer select-none'
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {name}
    </div>
  );
};

export default CustomButton;
